import React, { useState } from "react";
 
import { FileEarmarkPdf } from "react-bootstrap-icons";
 // We set a fixed width for the drawer

const FileViewer = ({ depositData,files }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleOpenFile = (file) => {
    setSelectedFile(file);
    setDrawerOpen(true);
  };

   
  const depositFiles = depositData?.files || [];
  const hasFiles = (depositFiles.length > 0) || (files?.length > 0);
  const data = depositFiles.length > 0 ? depositFiles : files || [];
 
  return (
    <div >
      {/* MAIN CONTENT AREA */}
      <div>
        {/* Files list */}
        <div className=" rounded p-3">
    {hasFiles ? (
      data.map((file, index) => (
        <div
          key={index}
          style={{ cursor: "pointer" }}
          className="text-decoration-none d-flex align-items-center justify-content-center text-dark mb-2"
          onClick={() => handleOpenFile(file)}
        >
          <FileEarmarkPdf size={25} className="me-2 text-danger" />
          <span className="ms-2 text-muted">
            ({(file.fileSize / 1024).toFixed(2)} KB)
          </span>
          <span className="fw-bold">{file.validationFieldName || "الملف المرفق"}  </span>
        </div>
      ))
    ) : (
      <p className="text-center text-danger fw-bold">
        لم يتم رفع ملفات
      </p>
    )}
  </div>

        {/* Minimal inline PDF or "selected file" display */}
        {selectedFile && (
          <div style={{ marginTop: "20px" }}>
            {/* <h5>عرض الملف</h5> */}
                <a className="text-light" href={selectedFile.filePath} target="_blank" rel="noreferrer">
                  افتح الملف في علامة تبويب جديدة
                </a>
            <embed
              src={selectedFile.filePath}
              type="application/pdf"
              style={{ width: "100%", height: "600px" }}
            />
          </div>
        )}
      </div>
 
    </div>
  );
};

export default FileViewer;